/**
 * @desc 样品确认-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.ProductConfirmResponseDto>;
export function request(pscno: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/productConfirm/details/${pscno}`, {
      method: "GET",

      ...options,
    }),
  );
}
